var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar25(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-30",
    "data-name": "50_Kids_Icons-30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M0,40.518A40,40,0,1,1,40.519,80,40,40,0,0,1,0,40.518Z",
    transform: "translate(0)",
    fill: "#3d2a3d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4571",
    "data-name": "Group 4571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4539",
    "data-name": "Group 4539",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M160.731,246.493c1.025,2.428.467,4.787-1.247,5.27s-3.933-1.093-4.958-3.521-.467-4.787,1.247-5.27S159.706,244.065,160.731,246.493Z",
    transform: "translate(-129.948 -204.934)",
    fill: "#e38a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M327.785,246.492c-1.025,2.428-.467,4.787,1.247,5.27s3.933-1.093,4.958-3.521.467-4.787-1.247-5.27S328.81,244.065,327.785,246.492Z",
    transform: "translate(-276.135 -204.934)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4540",
    "data-name": "Group 4540",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M136.183,412.258l-.008-.132c0-8-2.995-15.753-6.652-17.229l-15.575-6.275a20.633,20.633,0,0,0-13.3-.017l-15.8,6.312c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132Z",
    transform: "translate(-65.966 -326.964)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4541",
    "data-name": "Group 4541",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M234.763,277.007a6.219,6.219,0,0,1-6.219,6.219h-.754a6.219,6.219,0,0,1-6.219-6.219V260.989a6.219,6.219,0,0,1,6.219-6.219h.754a6.219,6.219,0,0,1,6.219,6.219Z",
    transform: "translate(-186.951 -214.962)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4543",
    "data-name": "Group 4543",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4542",
    "data-name": "Group 4542",
    transform: "translate(27.833 18.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M204.9,143.36a10.422,10.422,0,0,1-10.423,10.422h-5.923A10.422,10.422,0,0,1,178.13,143.36V126.306a10.422,10.422,0,0,1,10.422-10.422h5.923A10.422,10.422,0,0,1,204.9,126.306Z",
    transform: "translate(-178.13 -115.884)",
    fill: "#f5b68c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4544",
    "data-name": "Group 4544",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_103",
    "data-name": "Ellipse 103",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(34.537 40.012)",
    fill: "#4a87a3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_104",
    "data-name": "Ellipse 104",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(44.8 40.012)",
    fill: "#4a87a3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4545",
    "data-name": "Group 4545",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M178.945,102.076c-8.677,0-15.711,7.624-15.711,17.029a18.05,18.05,0,0,0,2.13,8.566l1.561-13.238h24.037l1.564,13.239a18.051,18.051,0,0,0,2.13-8.566C194.656,109.7,187.622,102.076,178.945,102.076Z",
    transform: "translate(-137.729 -86.127)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4546",
    "data-name": "Group 4546",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M252.214,279.542a2.384,2.384,0,0,1-4.653.538,2.526,2.526,0,0,0-.114.71,2.553,2.553,0,1,0,5.105,0A2.516,2.516,0,0,0,252.214,279.542Z",
    transform: "translate(-208.783 -235.864)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4547",
    "data-name": "Group 4547",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M136.174,425.067c0-8-3-15.753-6.652-17.229l-12.384-4.989a10.937,10.937,0,0,1-19.889.053l-12.4,4.956c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132h58Z",
    transform: "translate(-65.966 -339.904)",
    fill: "#d12c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4548",
    "data-name": "Group 4548",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M186.765,120.554l-1.17-3.975L169.1,128.586v8.136l10.3-2.551C185.257,132.721,188.552,126.625,186.765,120.554Z",
    transform: "translate(-142.681 -98.364)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M293.191,157.8a32.017,32.017,0,0,0-2.7-11.509,7.032,7.032,0,1,0,2.7,11.509Z",
    transform: "translate(-237.181 -123.09)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4550",
    "data-name": "Group 4550",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4549",
    "data-name": "Group 4549",
    transform: "translate(35.843 48.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M229.4,310.9c0,.029,0,.062,0,.092a5.373,5.373,0,1,0,10.746,0c0-.031,0-.064,0-.092Z",
    transform: "translate(-229.398 -310.902)",
    fill: "#a91935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M240.326,310.9v.46a1.687,1.687,0,0,0,1.687,1.688h5.528a1.688,1.688,0,0,0,1.689-1.688v-.46Z",
    transform: "translate(-238.618 -310.902)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4551",
    "data-name": "Group 4551",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    cx: 3.125,
    cy: 2.344,
    rx: 3.125,
    ry: 2.344,
    transform: "translate(46.685 43.107)",
    fill: "#eb987f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    cx: 3.125,
    cy: 2.344,
    rx: 3.125,
    ry: 2.344,
    transform: "translate(29.497 43.107)",
    fill: "#eb987f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4554",
    "data-name": "Group 4554",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4552",
    "data-name": "Group 4552",
    transform: "translate(33.125 37.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M213.188,243.3a2.882,2.882,0,0,1,2.748-.626.686.686,0,0,0,.365-1.322,4.3,4.3,0,0,0-4.082.978c-.656.6.317,1.563.97.97Z",
    transform: "translate(-212 -241.192)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4553",
    "data-name": "Group 4553",
    transform: "translate(44.864 37.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M291.7,242.333a4.3,4.3,0,0,0-4.082-.978.686.686,0,0,0,.365,1.322,2.882,2.882,0,0,1,2.748.626c.653.593,1.626-.374.97-.97Z",
    transform: "translate(-287.131 -241.192)",
    fill: "#fceeb3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4555",
    "data-name": "Group 4555",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M64.279,235.091h2.813l3.438,12.5H61.154Z",
    transform: "translate(-51.599 -198.358)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4564",
    "data-name": "Group 4564",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4563",
    "data-name": "Group 4563",
    transform: "translate(9.313 10.619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4556",
    "data-name": "Group 4556",
    transform: "translate(20.61 0.768)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_107",
    "data-name": "Ellipse 107",
    cx: 3.453,
    cy: 2.96,
    rx: 3.453,
    ry: 2.96,
    transform: "matrix(0.787, -0.617, 0.617, 0.787, 0, 4.263)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    cx: 3.453,
    cy: 2.96,
    rx: 3.453,
    ry: 2.96,
    transform: "matrix(0.787, -0.617, 0.617, 0.787, 0.822, 7.797)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4557",
    "data-name": "Group 4557",
    transform: "translate(16.213)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_109",
    "data-name": "Ellipse 109",
    cx: 3.331,
    cy: 2.855,
    rx: 3.331,
    ry: 2.855,
    transform: "matrix(0.787, -0.617, 0.617, 0.787, 0, 4.112)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 3.331,
    cy: 2.855,
    rx: 3.331,
    ry: 2.855,
    transform: "matrix(0.787, -0.617, 0.617, 0.787, 0.793, 7.521)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4558",
    "data-name": "Group 4558",
    transform: "translate(11.586 1.265)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    cx: 3.208,
    cy: 2.75,
    rx: 3.208,
    ry: 2.75,
    transform: "matrix(0.787, -0.617, 0.617, 0.787, 0, 3.96)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 3.208,
    cy: 2.75,
    rx: 3.208,
    ry: 2.75,
    transform: "matrix(0.787, -0.617, 0.617, 0.787, 0.764, 7.245)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4559",
    "data-name": "Group 4559",
    transform: "translate(7.192 4.134)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    cx: 3.086,
    cy: 2.645,
    rx: 3.086,
    ry: 2.645,
    transform: "matrix(0.787, -0.617, 0.617, 0.787, 0, 3.809)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    cx: 3.086,
    cy: 2.645,
    rx: 3.086,
    ry: 2.645,
    transform: "matrix(0.787, -0.617, 0.617, 0.787, 0.735, 6.968)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4560",
    "data-name": "Group 4560",
    transform: "translate(3.489 8.177)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 2.963,
    cy: 2.54,
    rx: 2.963,
    ry: 2.54,
    transform: "matrix(0.787, -0.617, 0.617, 0.787, 0, 3.658)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 2.963,
    cy: 2.54,
    rx: 2.963,
    ry: 2.54,
    transform: "matrix(0.787, -0.617, 0.617, 0.787, 0.706, 6.692)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4561",
    "data-name": "Group 4561",
    transform: "translate(0.938 12.964)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    cx: 2.841,
    cy: 2.435,
    rx: 2.841,
    ry: 2.435,
    transform: "matrix(0.787, -0.617, 0.617, 0.787, 0, 3.507)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    cx: 2.841,
    cy: 2.435,
    rx: 2.841,
    ry: 2.435,
    transform: "matrix(0.787, -0.617, 0.617, 0.787, 0.677, 6.415)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4562",
    "data-name": "Group 4562",
    transform: "translate(0 18.066)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_119",
    "data-name": "Ellipse 119",
    cx: 2.719,
    cy: 2.33,
    rx: 2.719,
    ry: 2.33,
    transform: "matrix(0.787, -0.617, 0.617, 0.787, 0, 3.356)",
    fill: "#fceeb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    cx: 2.719,
    cy: 2.33,
    rx: 2.719,
    ry: 2.33,
    transform: "matrix(0.787, -0.617, 0.617, 0.787, 0.647, 6.139)",
    fill: "#fceeb3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4569",
    "data-name": "Group 4569",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4568",
    "data-name": "Group 4568",
    transform: "translate(28.836 8.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4567",
    "data-name": "Group 4567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4565",
    "data-name": "Group 4565",
    transform: "translate(0 5.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M187.864,91.772c-2.562-.351-3.931.986-3.042,2.971l2.351,5.25c.889,1.985,2.8,1.854,4.242-.291l1.962-2.915c1.444-2.145.529-4.187-2.033-4.538Z",
    transform: "translate(-184.551 -91.716)",
    fill: "#d12c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4566",
    "data-name": "Group 4566",
    transform: "translate(9.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M247.733,57.7c1.444-2.145,3.353-2.276,4.242-.291l2.351,5.25c.889,1.985-.48,3.322-3.042,2.971l-3.481-.477c-2.562-.351-3.477-2.393-2.033-4.538Z",
    transform: "translate(-245.086 -56)",
    fill: "#d12c2c"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M233.153,89.181a2.7,2.7,0,1,1-3.563-1.359A2.7,2.7,0,0,1,233.153,89.181Z",
    transform: "translate(-192.371 -73.901)",
    fill: "#d12c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4570",
    "data-name": "Group 4570",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M80,233.665l-3.066.606a.781.781,0,0,1-.918-.615h0a.781.781,0,0,1,.615-.918l3.066-.606a.781.781,0,0,1,.918.615h0A.781.781,0,0,1,80,233.665Z",
    transform: "translate(-64.125 -195.849)",
    fill: "#d12c2c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar25);
export default __webpack_public_path__ + "static/media/avatar25.388dda19bf44398e1aaef9c3e7304a22.svg";
export { ForwardRef as ReactComponent };